/**
 * The zoom affordance for a chart — a small overlay in the chart's corner, since
 * ctrl/⌘+wheel on its own is not discoverable.
 *
 * `data-no-drag` keeps the dashboard grid from treating a click here as a card drag, and the
 * click is stopped from bubbling so `ViewCard`'s click-to-open popup doesn't fire either.
 */

import { Minus, Plus, RotateCcw } from "lucide-react";

import type { ChartZoomControls } from "./use-chart-zoom";

const BUTTON =
  "flex h-5 w-5 items-center justify-center rounded border border-border bg-card/90 text-muted-foreground transition-colors hover:text-foreground disabled:opacity-40";

export function ZoomControls({ controls }: { controls: ChartZoomControls }) {
  return (
    <div
      data-no-drag
      className="absolute top-0 right-0 z-10 flex gap-1 opacity-0 transition-opacity group-focus-within/chart:opacity-100 group-hover/chart:opacity-100"
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className={BUTTON}
        aria-label="Zoom out"
        title="Zoom out"
        disabled={!controls.zoomed}
        onClick={controls.zoomOut}
      >
        <Minus className="h-3 w-3" />
      </button>
      <button
        type="button"
        className={BUTTON}
        aria-label="Zoom in"
        title="Zoom in (or ⌘/ctrl + scroll)"
        onClick={controls.zoomIn}
      >
        <Plus className="h-3 w-3" />
      </button>
      <button
        type="button"
        className={BUTTON}
        aria-label="Reset zoom"
        title="Reset zoom"
        disabled={!controls.zoomed}
        onClick={controls.reset}
      >
        <RotateCcw className="h-3 w-3" />
      </button>
    </div>
  );
}
